export function calculateTop(imageHeight: number, scale: number) {
  return (imageHeight * (1 - scale)) / 2;
}
